import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import React from "react";
// import routing from './routing';
import { Provider } from "react-redux";
import configureStore from "../store/configureStore";
// import routesMiddleware from '../middleware/RoutesMiddleware';

import Index from "../component/index";
import Login from "../component/loginSeries/login";
import SignUp from "../component/loginSeries/signUp";
import ResetPWD from "../component/loginSeries/resetPWD";
import SupportedBrands from "../component/supportedBrands/supportedBrands";
import PrivacyPolicy from "../component/privacyPolicy";
import Invitation from "../component/invitation";
import { StringHelper, _} from "../strings"

const store = configureStore();

// https://tools.ietf.org/html/rfc5646
const supportLangCode = ["zh", "en", "ja"]
const slcRegex = "(" + supportLangCode.join("|") + ")"
var defaultLang = "en"

for(var i = 0; i < navigator.languages.length; i++){
	const clientString = navigator.languages[i]
	var found = false
	for(var j=0; j < supportLangCode.length; j++){
		const serverString = supportLangCode[j]
		if(clientString.startsWith(serverString) || serverString.startsWith(clientString)){
			defaultLang = serverString
			found = true
		}
	}
	if(found){
		break;
	}
}

console.log("default lang: ", defaultLang)
StringHelper.setDefaultLoacle(defaultLang)

export default (
	<Provider store={store}>
		<Router>
			<Routes>
				<Route path="/" element={<Index />} />
				<Route path="/en" element={<Index />} />
				
				<Route path="/login" element={<Login />} />
				<Route path="/en/login" element={<Login />} />

				<Route path="/sign-up" element={<SignUp />} />
				<Route path="/en/sign-up" element={<SignUp />} />

				<Route path="/reset-pwd" element={<ResetPWD />} />
				<Route path="/:lang_code/reset-pwd" element={<ResetPWD />} />

				<Route path="/supported-brands" element={<SupportedBrands />} />
				<Route path="/:lang_code/supported-brands" element={<SupportedBrands />} />

				<Route path="/privacy-policy" element={<Navigate to={`/${StringHelper.getLocale()}/privacy-policy`} replace />} />
				<Route path="/:lang_code/privacy-policy" element={<PrivacyPolicy />} />

				<Route path="/:lang_code/homes/:home_id/invitations/:invite_code" element={<Invitation />} />
			</Routes>
		</Router>
	</Provider>
)
